export const roundToMaxTwoDecimalPlaces = (number?: number) => {
	if (!number) return 0;

	return Math.round((number + Number.EPSILON) * 100) / 100;
}